module.exports = __webpack_public_path__ + "static/advanced-189bd9fb6a80f6f9351ee34f10a3379d.png";